import { useMediaQuery } from '@material-ui/core';
import React from 'react';

/**
 * GetMediaQuery.
 *
 * @returns {any}
 */
export default function GetMediaQuery({
    isMobile
}) {
    const matches = useMediaQuery('(max-width:760px)');

    React.useEffect(() => {
        if (matches) {

            isMobile(true);
        }
    }, [ matches, isMobile ]);

    return (
        <></>
    );
}
